import React from 'react';
import { useTheme } from '../../../context/ThemeContext';

/**
 * Reusable card component with theme support
 */
const CustomCard = ({ children, className = '', onClick, style = {} }) => {
  const { theme } = useTheme();

  return (
    <div
      className={`rounded-[6px] ${
        theme === 'dark'
          ? 'bg-[#0F0F0F] shadow-[0_2px_5px_1px_rgba(175,175,175,0.1)] text-white'
          : 'bg-white shadow-[0_2px_5px_1px_rgba(87,87,87,0.1)] text-black'
      } p-3 ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
};

export default CustomCard;
